import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { errorConfigNameSelector } from '@src/store/errorLogicConfig/configContainer/selectors';
import { updateConfigConditions } from '@store/errorLogicConfig/configContainer/actions';
import FilterRowGroup from './FilterRowGroup';
import { StyledFooter, StyledErrorMsg } from '../styled';

import { Input, Form } from 'antd';
import { renameShort } from '@src/utils/common';

function ConfigForm({ hasErrors }) {
  const dispatch = useDispatch();
  const name = useSelector(errorConfigNameSelector);

  const onChange = (e) => {
    dispatch(updateConfigConditions({ name: e.target.value }));
  };

  return (
    <Form layout="vertical">
      <Form.Item label="Config Name" required>
        <Input value={name} onChange={onChange} />
      </Form.Item>
      <FilterRowGroup />
      <StyledFooter>
        Note: This configuration will label {renameShort('VSF')} and {renameShort('VPF')} failures
        that match the specified value as business logic errors.
      </StyledFooter>
      {hasErrors && <StyledErrorMsg>Please fill in the required fields.</StyledErrorMsg>}
    </Form>
  );
}

export default ConfigForm;
